import Link from 'next/link'

import { Icon, IconComponent } from '@graftcode/design-system'

import { ACADEMY_ROUTES } from '@/shared/academy.const'
import { ACADEMY_BACK_LINK_TEST_IDS } from '@/shared/academy-test-ids.const'

import styles from './AcademyBackLink.module.scss'

type AcademyBackLinkProps = {
  className?: string
}

export function AcademyBackLink({ className }: AcademyBackLinkProps) {
  const linkClassName = className ? `${styles.link} ${className}` : styles.link

  return (
    <Link
      href={ACADEMY_ROUTES.home}
      className={linkClassName}
      aria-label="Go to Academy home"
      data-testid={ACADEMY_BACK_LINK_TEST_IDS.root}
    >
      <IconComponent icon={Icon.ArrowLeftRegular} size={16} className={styles.leadingArrow} />
      <span className={styles.iconBox}>
        <IconComponent icon={Icon.GCAcademy} size={20} />
      </span>
      <span className={styles.text}>
        <span className={styles.label}>Academy</span>
        <span className={styles.hint}>Back to home</span>
      </span>
    </Link>
  )
}
